import { UPDATE_CALENDAR_START, UPDATE_CALENDAR_SUCCESS, UPDATE_CALENDAR_FAILED } from '../actions/calendar'

export const STATUS_FAILED = 'STATUS_FAILED'
export const STATUS_LOADING = 'STATUS_LOADING'
export const STATUS_READY = 'STATUS_READY'

export const INITIAL_STATE = {
	calendar: [],
	calendarStatus: STATUS_FAILED,
}

const calendarReducer = ({calendar, calendarStatus} = INITIAL_STATE, action = {}) => {
	switch(action.type){
	case UPDATE_CALENDAR_START:
		return {
			calendar,
			calendarStatus: STATUS_LOADING,
		}
	case UPDATE_CALENDAR_SUCCESS:
		return {
			calendar: action.data,
			calendarStatus: STATUS_READY,
		}
	case UPDATE_CALENDAR_FAILED:
		return {
			calendar,
			calendarStatus: STATUS_FAILED,
		}
	default:
		return {
			calendar,
			calendarStatus,
		}
	}
}

export default calendarReducer



// WEBPACK FOOTER //
// ./src/reducers/calendar.js